/**
 * Initialize Product Variants Action
 * Triggered by: arc:action:initializeVariants
 */

export const runInitializeVariants = async (data = {}) => {
    try {
        const { autoSelectFirst = true, delayMs = 1000 } = data;

        // Initialize variant selection listeners
        initializeVariantListeners();
        
        // Initialize selling plan listeners
        initializeSellingPlanListeners();

        if (autoSelectFirst) {
            // Auto-select first variant with delay
            setTimeout(() => {
                const firstRadio = document.querySelector('.variant-selects input[type="radio"]');
                if (firstRadio) {
                    firstRadio.click();
                }
            }, delayMs);
        }

        // Dispatch initialization complete event
        window.dispatchEvent(new CustomEvent("variants:initialized", {
            detail: {
                autoSelectFirst,
                timestamp: Date.now()
            }
        }));

        return {
            success: true,
            message: 'Variants initialized successfully'
        };

    } catch (error) {
        console.error('Initialize Variants error:', error);
        
        window.dispatchEvent(new CustomEvent('variants:error', {
            detail: {
                error: error.message,
                action: 'initializeVariants'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

// Initialize variant selection event listeners
const initializeVariantListeners = () => {
    // Remove existing listeners to prevent duplicates
    const variantSelects = document.querySelectorAll('.variant-selects input[type="radio"]');
    
    variantSelects.forEach((radio) => {
        // Remove existing listener if any
        radio.removeEventListener("change", handleVariantChange);
        // Add new listener
        radio.addEventListener("change", handleVariantChange);
    });
};

// Initialize selling plan event listeners
const initializeSellingPlanListeners = () => {
    const sellingGroups = document.querySelectorAll('.product-selling-groups input[type="radio"]');
    
    sellingGroups.forEach((radio) => {
        // Remove existing listener if any
        radio.removeEventListener("change", handleSellingPlanChange);
        // Add new listener
        radio.addEventListener("change", handleSellingPlanChange);
    });
};

// Handle variant change events
const handleVariantChange = (event) => {
    // Trigger variant selection action
    window.dispatchEvent(new CustomEvent('arc:action:selectVariant', {
        detail: {
            variantElement: event.target,
            autoUpdate: true
        }
    }));
};

// Handle selling plan change events
const handleSellingPlanChange = (event) => {
    // Trigger selling plan selection action
    window.dispatchEvent(new CustomEvent('arc:action:selectSellingPlan', {
        detail: {
            sellingPlanElement: event.target,
            autoUpdate: true
        }
    }));
};

export default runInitializeVariants;
